import React, { useState } from "react";
import {
  faEnvelope,
  faMap,
  faMapMarker,
  faPhone,
  faMobileAlt,
  faArrowLeft,
} from "@fortawesome/free-solid-svg-icons";
import "./New_Contact_Us.css";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import New_full_screen from "../animation/new_full_screen/New_full_screen";
import { Success_lottie } from "../animation/success_lottie/Success_lottie";
import { Link, useNavigate } from "react-router-dom";
import Send_Btn from "../common_component/send_btn/Send_Btn";
import { useForm } from "react-hook-form";

const New_Contact_Us = () => {
  const [showMap, setShowMap] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showBg, setShowBg] = useState(false);
  const [showContactTextHolder, setShowContactTextHolder] = useState(true);
  const navigate = useNavigate();

  const onSubmit = async (data) => {
    console.log("Form submitted with:", data.name);

    const htmlFormat = `
<div style="font-family: Arial, sans-serif; color: #333; padding: 20px;">
  <h2>📩 New Contact Form Submission</h2>
  <table style="width:100%; border-collapse: collapse;">
    <tr>
      <td><b>Name</b></td>
      <td>${data.name}</td>
    </tr>
    <tr>
      <td><b>Email</b></td>
      <td>${data.email}</td>
    </tr>
    <tr>
      <td><b>Subject</b></td>
      <td>${data.subject}</td>
    </tr>
    <tr>
      <td><b>Message</b></td>
      <td>${data.message}</td>
    </tr>
  </table>
</div>
`;

    try {
      const payload = {
        email: "info.pmroad@gmail.com",
        subject: "demo",
        html: htmlFormat,
        key: "Profcyma",
      };

      const response = await fetch(
        "https://emailservices.hostelbliss.com:3301/common-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const result = await response.json();
      if (response.ok) {
        setShowModal(true);
        setTimeout(() => {
          navigate("/");
          setShowModal(false);
        }, 2500);
      } else {
        console.error("Form submission failed:", result);
      }
    } catch (error) {
      console.error("Submission error:", error);
    }
  };

  const [showModal, setShowModal] = useState(false);

  const handleMapTextClick = () => {
    setShowForm(true);
    setShowBg(true);
    setShowContactTextHolder(false);
  };

  const handleArrowClick = () => {
    setShowContactTextHolder(true);
    setShowForm(false);
    setShowBg(false);
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  return (
    <>
      <section className="contact-us">
        {/* MAP */}
        <div className="map-section">
          <div className="mapouter">
            <div className="gmap_canvas">
              <iframe
                className="gmap_iframe"
                frameBorder="0"
                scrolling="no"
                marginHeight="0"
                marginWidth="0"
                src="https://maps.google.com/maps?q=21.97252726574854,71.57984962005898&z=15&output=embed"
              ></iframe>
            </div>
          </div>
        </div>

        <div
          className={`contact_form_holder ${showBg ? "contact_form_bg" : ""}`}
        >
          <div className="container">
            <div className="row justify-content-end">
              <div className="col-lg-4 col-md-4">
                <div
                  className={`contact-text-holder ${
                    showContactTextHolder ? "" : "d-none"
                  }`}
                >
                  <div className="heading-holder mb-4">
                    <h2>Contact Us</h2>
                  </div>

                  <div className="contact-item">
                    <div className="icons_holder">
                      <FontAwesomeIcon
                        icon={faPhone}
                        className="contact-icon"
                      />
                    </div>
                    <p>
                      <b>Customer Care:</b> +91 94087 24365
                    </p>
                  </div>

                  <div className="contact-item">
                    <div className="icons_holder">
                      <FontAwesomeIcon
                        icon={faPhone}
                        className="contact-icon"
                      />
                    </div>
                    <p>
                      <b>Help Center:</b> +91 8347024365
                    </p>
                  </div>

                  <div className="contact-item">
                    <div className="icons_holder">
                      <FontAwesomeIcon
                        icon={faPhone}
                        className="contact-icon"
                      />
                    </div>
                    <p>
                      <b>Toll Free:</b> +91 1800 24365
                    </p>
                  </div>

                  <div className="contact-item">
                    <div className="icons_holder">
                      <FontAwesomeIcon
                        icon={faEnvelope}
                        className="contact-icon"
                      />
                    </div>
                    <div className="all_links_holder">
                      <div className="links_holder">
                        <a
                          href="mailto:help.pmroad@gmail.com"
                          className="contact-text"
                        >
                          help.pmroad@gmail.com
                        </a>
                      </div>

                      <div className="links_holder">
                        <a
                          href="mailto:info.pmroad@gmail.com"
                          className="contact-text"
                        >
                          info.pmroad@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className="contact-item">
                    <div className="icons_holder">
                      <FontAwesomeIcon
                        icon={faMapMarker}
                        className="contact-icon"
                      />
                    </div>
                    <p>
                      <b>Head Office:</b> 1st floor, AtoZ, Botad Road,
                      Gadhada-364750, Gujrat, India.
                      <br />
                      <br />
                      <b>Branch Office:</b> 112, 99-Business Center, Amroli to
                      Sayan Road-394107, Surat, India.
                    </p>
                  </div>

                  <div className="contact-item map-click">
                    <div className="icons_holder">
                      <FontAwesomeIcon icon={faMap} className="contact-icon" />
                    </div>
                    <p onClick={handleMapTextClick} className="map-text">
                      Find Us on Map
                    </p>
                  </div>

                  <div className="border-holder my-4"></div>
                  <div className="contact-item"></div>

                  <div className="social-icon">
                    <div className="icons_holder">
                      <FontAwesomeIcon
                        icon={faMobileAlt}
                        className="contact-icon"
                      />
                    </div>

                    <Link
                      to="https://www.facebook.com/share/17xh1pQu18/"
                      target="blank"
                    >
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/footer/facebook.png"
                        }
                        className="facebook-icon me-2"
                      />
                    </Link>

                    <Link
                      to="https://youtube.com/@pmroad?si=-8XQNJt4daYb2WiF"
                      target="blank"
                    >
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/footer/youtube.png"
                        }
                        className="facebook-icon me-2"
                      />
                    </Link>
                    <Link to="https://x.com/PMROAD1" target="blank">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/footer/twitter.png"
                        }
                        className="facebook-icon me-2"
                      />
                    </Link>

                    <Link
                      to="https://www.instagram.com/pm.road?utm_source=qr&igsh=MXdubzJpbnI4ODhkdA==
"
                      target="blank"
                    >
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/footer/instagram.png"
                        }
                        className="facebook-icon me-2"
                      />
                    </Link>

                    <Link
                      to="https://www.threads.com/@pm.road
"
                      target="blank"
                    >
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/footer/thread.png"
                        }
                        className="facebook-icon"
                      />
                    </Link>
                  </div>
                </div>
              </div>

              <div
                className={`${
                  showForm
                    ? "col-xl-5 col-lg-7 col-12 scale-down-hor-right"
                    : "col-lg-8 col-md-8 scale-up-hor-right"
                }`}
              >
                <div className="form-holder">
                  <div
                    className={`arrow-holder ${
                      showForm ? "arrow-holder" : "d-none"
                    }`}
                    onClick={handleArrowClick}
                  >
                    <button
                      type="button"
                      className="back-btn"
                      onClick={() => setShowMap(false)}
                    >
                      <FontAwesomeIcon icon={faArrowLeft} />
                    </button>

                    {/* <img
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/Image/Icon/arrow-left.png"
                      }
                      className="left-arrow"
                    /> */}
                  </div>

                  <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row className="form_container">
                      <Form.Group className="mb-3">
                        <Form.Control
                          type="text"
                          placeholder="Your Name"
                          {...register("name", {
                            required: "Name is required",
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.name,
                          })}
                        />
                        {errors.name && (
                          <div className="invalid-feedback">
                            {errors.name.message}
                          </div>
                        )}
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Control
                          type="text"
                          placeholder="E-mail"
                          {...register("email", {
                            required: "E-mail Address is required",
                            pattern: {
                              value: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
                              message: "Invalid Email Address",
                            },
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.email,
                          })}
                        />
                        {errors.email && (
                          <div className="invalid-feedback">
                            {errors.email.message}
                          </div>
                        )}
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Control
                          type="text"
                          placeholder="Subject"
                          {...register("subject", {
                            required: "Subject is required",
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.subject,
                          })}
                        />
                        {errors.subject && (
                          <div className="invalid-feedback">
                            {errors.subject.message}
                          </div>
                        )}
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Control
                          as="textarea"
                          rows={3}
                          placeholder="Your Message"
                          {...register("message", {
                            required: "Message is required",
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.message,
                          })}
                        />
                        {errors.message && (
                          <div className="invalid-feedback">
                            {errors.message.message}
                          </div>
                        )}
                      </Form.Group>

                      <div className="btn-holder">
                        <Send_Btn type="submit" />
                      </div>
                    </Row>
                  </Form>
                </div>

                {!showBg && (
                  <p className="bottom_text">
                    Sponsored by Vaghani International Business Pvt. Ltd.
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>

        <New_full_screen
          show={showModal}
          onHide={() => setShowModal(false)}
          lottie={<Success_lottie />}
        />
      </section>
    </>
  );
};

export default New_Contact_Us;
